import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=f94e2f14&scoped=true&"
import script from "./Setname.vue?vue&type=script&lang=js&"
export * from "./Setname.vue?vue&type=script&lang=js&"
import style0 from "./Setname.vue?vue&type=style&index=0&id=f94e2f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94e2f14",
  null
  
)

export default component.exports